
import React, { useEffect, useState } from 'react';
import { AppBar, Tabs, Tab, Box, Typography, Grid, MenuItem, Select, Button, Divider } from '@material-ui/core';
import { useDispatch } from 'react-redux';

import { eventParticipants } from '../../../../data-store/actions/registry-actions';
import SimpleDialogDemo from '../../Modals/SimpleDialog';
import LogoOverlayEditor from '../../PhotoEditor/LogoOverlayEditor';
import CanvasEditor from '../../PhotoEditor/CanvasEditor';
import ConfiguracionFotosEvento from './ConfiguracionFotosEvento';
import { eventPhotoConfiguration } from '../../../../data-store/actions/events-actions';
import PhotoGalleryView from './PhotoGalleryView';



function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={2}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
    };
}

export default function PhotosContainer({ eventoIndex }) {
    const dispatch = useDispatch();

    const [value, setValue] = React.useState(0);

    useEffect(() => {
        dispatch(eventParticipants(eventoIndex))
        dispatch(eventPhotoConfiguration(eventoIndex))

    }, [eventoIndex]);


    const handleChange = (event, newValue) => {
        setValue(newValue);
    };





    return (
        <>
            <AppBar position="static" color="default">
                <Tabs value={value} onChange={handleChange} indicatorColor="primary" textColor="primary" variant="scrollable" scrollButtons="auto">
                    <Tab label="Agregar logos en lote" {...a11yProps(0)} />
                    <Tab label="Fotos de atletas con marco (En proceso)" {...a11yProps(1)} />
                    <Tab label="Revisar fotos cargadas" {...a11yProps(2)} />
                </Tabs>
            </AppBar>

            <TabPanel value={value} index={0}>
                {/* Aquí puedes colocar el componente de subida de logos en lote */}

                <Grid container justify="center">
                    <Grid item xs={12} sm={3}>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <LogoOverlayEditor />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                    </Grid>
                </Grid>

            </TabPanel>
            <TabPanel value={value} index={1}>
                {/* Aquí colocas el generador de fotos con marco */}
                <Typography>Contenido para generar fotos de atletas con marco.</Typography>
                {/* <CanvasEditor
                    imageUrl="https://firebasestorage.googleapis.com/v0/b/kmetasfirebase.appspot.com/o/fotosVarias%2F1746408161100%2Fab178ddc-50e3-44af-992e-ecf5e1ca34bb._25865.JPG?alt=media&token=390f1826-e1aa-484e-9f54-c5077d32c2a6"
                    frameUrl="https://firebasestorage.googleapis.com/v0/b/kmetasfirebase.appspot.com/o/MarcosFotos%2FMarcoBordeNegroRecto.png?alt=media&token=7c73c524-8033-4285-be82-8b818b1cf21e"
                    logoUrl="https://firebasestorage.googleapis.com/v0/b/kmetasfirebase.appspot.com/o/fotosVarias%2F1746407782888%2Fef979195-74c4-4817-8fea-71ef269d0146._23437.JPG?alt=media&token=434127d5-bfa8-4f49-b9e5-bc4734d9f198"
                    initialName="Eduardo"
                    initialNumber="207"
                /> */}
            </TabPanel>
            <TabPanel value={value} index={2}>
                {/* Opcional: vista previa de fotos */}
                <Typography>Contenido para revisar fotos cargadas.</Typography>
                <PhotoGalleryView eventoIndex={eventoIndex} />
            </TabPanel>
        </>
    );
}
